import { FIELD_IS_VALID } from '../../../Constants';

const scienceValidation = (science) => {
  if (science === '' || science === null || science === undefined) {
    return 'collection_validation_science_is_required';
  }

  return FIELD_IS_VALID;
};

export default scienceValidation;